import React, { useState, useEffect } from 'react';
import { Link as ReactRouterLink, useNavigate } from 'react-router-dom';
import { Box, Flex, Link, Text, Button, useColorModeValue } from '@chakra-ui/react';
import { useAuth } from '../contexts/AuthContext';
import fetchWithAuth from '../utils/fetchWithAuth';
import logo from '../assets/logo-filled.svg';

function Header() {
  const bgColor = useColorModeValue('background.shade1');
  const hoverColor = useColorModeValue('theme.teal');
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [smsMode, setSmsMode] = useState(null);

  useEffect(() => {
    if (user) {
      fetchWithAuth('/api/server-config/')
        .then(res => res.ok ? res.json() : null)
        .then(data => { if (data) setSmsMode(data); })
        .catch(() => {});
    }
  }, [user]);

  const handleLogout = async () => {
    const result = await logout();
    if (result.success) {
      navigate('/conduct0r');
    }
  };

  const isLive = smsMode && !smsMode.twilio_dry_run;
  const isDryRun = smsMode && smsMode.twilio_dry_run;

  return (
    <>
      <Box bg={bgColor} py={4}>
        <Flex justifyContent="center" mx="2rem">
          <Flex alignItems="center" width="100%" justifyContent="space-between">
            <Text textStyle="h2" textAlign="left" flex="1">
              Blackbird
            </Text>
            <Link as={ReactRouterLink} to="/" flex="none">
              <img src={logo} alt="Blackbird Logo" style={{ width: '3rem', height: 'auto' }} />
            </Link>
            <Flex flex="1" justifyContent="flex-end" alignItems="center">
              <Link as={ReactRouterLink} to="/pollsPage" mx={2} _hover={{ color: hoverColor }} textDecoration="none">
                <Text fontSize="sm" fontWeight="500">Polls</Text>
              </Link>
              <Link as={ReactRouterLink} to="/populations" mx={2} _hover={{ color: hoverColor }} textDecoration="none">
                <Text fontSize="sm" fontWeight="500">Populations</Text>
              </Link>
              <Link as={ReactRouterLink} to="/audiences" mx={2} _hover={{ color: hoverColor }} textDecoration="none">
                <Text fontSize="sm" fontWeight="500">Audiences</Text>
              </Link>
              <Link as={ReactRouterLink} to="/stagingpoll" mx={2} _hover={{ color: hoverColor }} textDecoration="none">
                <Text fontSize="sm" fontWeight="500">Stage</Text>
              </Link>
              <Link as={ReactRouterLink} to="/live-polls" mx={2} _hover={{ color: hoverColor }} textDecoration="none">
                <Text fontSize="sm" fontWeight="500">Live</Text>
              </Link>
              <Link as={ReactRouterLink} to="/results" mx={2} _hover={{ color: hoverColor }} textDecoration="none">
                <Text fontSize="sm" fontWeight="500">Results</Text>
              </Link>
              {user && (
                <>
                  <Text fontSize="sm" color="theme.mediumGray" mx={2}>
                    {user.username}
                  </Text>
                  <Button
                    size="sm"
                    variant="secondary"
                    onClick={handleLogout}
                    ml={2}
                  >
                    Logout
                  </Button>
                </>
              )}
            </Flex>
          </Flex>
        </Flex>
      </Box>
      {smsMode && (
        <Box
          bg={isLive ? '#DC2626' : '#1a7f72'}
          py={1}
          px={4}
          textAlign="center"
        >
          <Text fontSize="xs" fontWeight="700" color="white" letterSpacing="0.05em">
            {isLive
              ? 'LIVE MODE — SMS messages will be sent to real phone numbers'
              : 'DRY RUN — SMS messages are simulated, not sent'}
          </Text>
        </Box>
      )}
    </>
  );
}

export default Header;
